/* Ki Jewelry: show "-X% OFF" on product-card sale badges instead of "Sale" */
(function () {
  function toNumber(el) {
    if (!el) return 0;
    var n = parseFloat(el.textContent.replace(/[^0-9.]/g, ''));
    return isNaN(n) ? 0 : n;
  }
  function updateBadges(root) {
    (root || document).querySelectorAll('.card-wrapper').forEach(function (card) {
      var price = card.querySelector('.price--on-sale');
      if (!price || price.classList.contains('price--sold-out')) return;
      var compare = toNumber(price.querySelector('.price__sale s.price-item--regular'));
      var sale = toNumber(price.querySelector('.price__sale .price-item--sale'));
      if (!compare || !sale || compare <= sale) return;
      var pct = Math.floor(((compare - sale) * 100) / compare);
      card.querySelectorAll('.card__badge .badge').forEach(function (b) {
        if (!b.dataset.kiPct) { b.textContent = '-' + pct + '% OFF'; b.dataset.kiPct = pct; }
      });
    });
  }
  document.addEventListener('DOMContentLoaded', function () {
    updateBadges();
    new MutationObserver(function () { updateBadges(); }).observe(document.body, { childList: true, subtree: true });
  });
})();
